import { QueryClient } from "@tanstack/react-query";
import { listTemplateQueryKey } from "components/ListTemplate";
import { planningTemplateQueryKey } from "Planning/PlanningTemplate";
import { itinerarySidebarQueryKey } from "show/ItinerarySidebar/base";

export const invalidateShowsCache = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: ["planning_Map_Show"] });
  queryClient.invalidateQueries({ queryKey: ["show-list-with-sales"] });
  queryClient.invalidateQueries({ queryKey: ["showsTotals"] });
  queryClient.invalidateQueries({ queryKey: ["linkedShowsToFlight"] });
  queryClient.invalidateQueries({ queryKey: ["lastModifiedShows"] });
  queryClient.invalidateQueries({ queryKey: ["ESignAgencyDashboard"] });
  queryClient.invalidateQueries({ queryKey: [itinerarySidebarQueryKey] });
  queryClient.invalidateQueries({ queryKey: [planningTemplateQueryKey] });
  queryClient.invalidateQueries({ queryKey: [listTemplateQueryKey] });
}